// @packages
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// @scripts
import CategoryPage from './CategoryPageDisplay';

const CategoryPageContainer = () => (<CategoryPage id="fan-wizard-page" />);

CategoryPageContainer.propTypes = {
};

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
}, dispatch);

export default connect(
    mapStateToProps, mapDispatchToProps
)(CategoryPageContainer);
